import React from 'react';
import { Layout } from './components/Layout';
import { ToastProvider } from './components/Toast';
export function App() {
  return <ToastProvider data-id="element-0">
      <Layout data-id="element-1" />
    </ToastProvider>;
}